import React from 'react';
import { Dialog } from '../../../../Components/MUIs';
import { LEG_BASIC_LAW_SELECT_OPTIONS } from './LEG_BASIC_Constants';
import './LEG_BASIC_LawSelectDialog.styles.css';

const OPTION_META = {
  DEFAULT: {
    cardClass: 'leg-law-select__card--default',
    icon: 'gavel',
    badge: '기본 제공',
  },
  NEW: {
    cardClass: 'leg-law-select__card--new',
    icon: 'add_circle',
    badge: null,
  },
};

/** 법규준수평가 실시 — 점검표(법령) 선택 팝업 */
function LEG_BASIC_LawSelectDialog({
  open = false,
  onClose = () => {},
  onSelect = () => {},
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="점검표 선택"
      maxWidth="sm"
      fullWidth
      useSaveButton={false}
      closeButtonName="닫기"
      titleSx={{ pb: 1.5, fontWeight: 700, fontSize: 18 }}
      contentSx={{ pt: 1, px: 2.5, pb: 2.5 }}
      content={
        <div className="leg-law-select">
          <div className="leg-law-select__intro">
            <div className="leg-law-select__intro-icon">
              <span className="material-symbols-outlined">fact_check</span>
            </div>
            <div>
              <div className="leg-law-select__intro-title">
                실시할 법령 점검표를 선택하세요
              </div>
              <p className="leg-law-select__intro-desc">
                기본 제공 점검표를 사용하거나, 사업장에 맞는 신규 법령 점검표를
                만들 수 있습니다.
              </p>
            </div>
          </div>

          <div className="leg-law-select__list">
            {LEG_BASIC_LAW_SELECT_OPTIONS.map((option) => {
              const meta = OPTION_META[option.id] || OPTION_META.NEW;
              return (
                <button
                  key={option.id}
                  type="button"
                  className={`leg-law-select__card ${meta.cardClass}`}
                  onClick={() => onSelect(option.id)}
                >
                  <div className="leg-law-select__card-icon">
                    <span className="material-symbols-outlined">{meta.icon}</span>
                  </div>
                  <div className="leg-law-select__card-body">
                    <div className="leg-law-select__card-top">
                      <span className="leg-law-select__card-title">
                        {option.name}
                      </span>
                      {meta.badge ? (
                        <span className="leg-law-select__badge">{meta.badge}</span>
                      ) : null}
                    </div>
                    {option.description ? (
                      <p className="leg-law-select__card-desc">
                        {option.description}
                      </p>
                    ) : null}
                  </div>
                  <span className="leg-law-select__card-arrow">
                    <span className="material-symbols-outlined">chevron_right</span>
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      }
    />
  );
}

export default LEG_BASIC_LawSelectDialog;
